import * as React from "react";
import NavigationBuilderContext from "./NavigationBuilderContext";
/**
 * Hook for passing focus callback to children
 */ export default function useFocusedListenersChildrenAdapter(param) {
    var navigation = param.navigation, focusedListeners = param.focusedListeners;
    var addListener = React.useContext(NavigationBuilderContext).addListener;
    var listener = React.useCallback(function(callback) {
        if (navigation.isFocused()) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = focusedListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var listener = _step.value;
                    var _listener = listener(callback), handled = _listener.handled, result = _listener.result;
                    if (handled) {
                        return {
                            handled: handled,
                            result: result
                        };
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                handled: true,
                result: callback(navigation)
            };
        } else {
            return {
                handled: false,
                result: null
            };
        }
    }, [
        focusedListeners,
        navigation
    ]);
    React.useEffect(function() {
        return addListener === null || addListener === void 0 ? void 0 : addListener("focus", listener);
    }, [
        addListener,
        listener
    ]);
}
